import { useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { useSelector } from "react-redux";
import { getordershistory } from "../../../../../shared/slice/order/OrderService";
import { store } from "../../../../../shared";
import { setOrdersHistory } from "../../../../../shared/slice/order/OrderSlice";
import { styled as styledmui } from '@mui/material/styles';
import styled from "styled-components";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import getSymbolFromCurrency from "currency-symbol-map";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import OrderHistoryModal from "./OrderHistoryModal/OrderHistoryModal";
import { reformulateItems, reformulatePromo } from "../../../../../utils/utils-functions";
import MyNavBar from "../../../../../components/Navbar/MyNavBar";
import { lighten } from "polished";
import { useTranslation } from "react-i18next";

export default function OrdersHistory() {
   
    const restaurantSelected = useSelector(
        (state) => state.restaurant.restaurantSelected
    );
    const { storeId } = useParams();
    const navigate = useNavigate()
    const userId = useSelector((state) => state.authentification.userId)
    const ordershistory = useSelector((state) => state.order.OrdersHistory)
    // console.log("storeId",storeId)
    useEffect(() => {
        if (userId) {
            store.dispatch(setOrdersHistory({ OrdersHistory: null }))
            const fetchstorebyid = async () => {
                await getordershistory({ userId, storeId }).then(async (res) => {
                    store.dispatch(setOrdersHistory({ OrdersHistory: res.data }));
                }).catch(err => {
                    navigate(`/page404`);
                })
            }
            fetchstorebyid()
        } else {
            navigate(`/page404`)
        }
    }, [])

 
    document.documentElement.style.setProperty("--primaryColor", restaurantSelected.primairecolor);
    document.documentElement.style.setProperty("--secondaryColor", restaurantSelected.secondairecolor);
    document.documentElement.style.setProperty(
        "--primaryColorLight",
        lighten("0.3", restaurantSelected.primairecolor)
    );
    return (
        ordershistory && restaurantSelected && <div>
            <MyNavBar />
            {/* < /> */}
            <PaginatedItems itemsPerPage={10} ordershistory={ordershistory} />
        </div>

    )

}
// const items = [...Array(33).keys()];

function Items({ currentItems, Favorites }) {
    const { t } = useTranslation();
    const StyledTableCell = styledmui(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            padding: 3,
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
            padding: 3,
            fontSize: 14,
        },
    }));

    const StyledTableRow = styledmui(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
        },
    }));

    const currency = useSelector((state) => state.restaurant.menu.currency)
    const [order, setOrder] = useState({
        state: false,
        data: null
    })
    const userId = useSelector((state) => state.authentification.userId)
    return (
        <div>
            {order.state && <OrderHistoryModal order={order} setOrder={setOrder} />}
            <TableContainer component={Paper}>
                <Table aria-label="customized table">
                    <TableHead >
                        <TableRow >
                            {/* <StyledTableCell align="left" style={{
                                backgroundColor: "#444",
                            }}>ID</StyledTableCell> */}
                            <StyledTableCell style={{
                                backgroundColor: "#444"
                            }} align="left">{t('TIME')}</StyledTableCell>
                            <StyledTableCell style={{
                                backgroundColor: "#444"
                            }} align="left">{t('MODE')}</StyledTableCell>
                            <StyledTableCell style={{
                                backgroundColor: "#444"
                            }} align="left">{t('STATUS')}</StyledTableCell>
                            <StyledTableCell style={{
                                backgroundColor: "#444"
                            }} align="left">{t('PAYMENT')}</StyledTableCell>
                            <StyledTableCell style={{
                                backgroundColor: "#444"
                            }} align="left">{t('TOTAL')}</StyledTableCell>
                            <StyledTableCell style={{
                                backgroundColor: "#444"
                            }} align="left">{t('VIEW')}</StyledTableCell>
                            {/* <StyledTableCell style={{
                                backgroundColor: "#444"
                            }} align="left">FAV</StyledTableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody >
                        {currentItems.map((row) => (
                            <StyledTableRow key={row?._id}>
                                {/* <StyledTableCell align="left" component="th" scope="row">
                                    {row._id.slice(row._id.length - 4, row._id.length)}
                                </StyledTableCell> */}
                                <StyledTableCell align="left">{new Date(row?.createdAt).toISOString().slice(0, 10)}<br />{new Date(row?.createdAt).toISOString().slice(11, 16)}</StyledTableCell>
                                <StyledTableCell align="left">{t(row?.type)}</StyledTableCell>
                                <StyledTableCell align="left">{t(row?.status)}</StyledTableCell>
                                <StyledTableCell align="left">{t(row?.paymentStatus)}</StyledTableCell>
                                <StyledTableCell align="left">{row?.price_total}{getSymbolFromCurrency(currency)}</StyledTableCell>
                                <StyledTableCell align="left"><div style={{ cursor: "pointer", color: "#444" }} onClick={() => {
                                    let newData = {
                                        ...row,
                                        items: reformulateItems(row?.items),
                                        promo: reformulatePromo(row?.promo),
                                    }
                                    setOrder({
                                        state: !order.state, data: newData
                                    })
                                }}><RemoveRedEyeIcon /></div></StyledTableCell>
                                {/* <StyledTableCell align="left"><div onClick={async () => {
                                    await managefavorites({ orderId: row._id, favorite: !row.favorite, userId: userId }).then(response => {
                                        store.dispatch(setFavoritesOrders({ Favorites: response.orders }))
                                        store.dispatch(modifyOrderHistory({ orderId: row._id }))
                                    }).catch(err => {
                                    })
                                }
                                } style={{ cursor: "pointer", color: Favorites.find((fav) => fav._id === row._id) ? "gold" : "#999" }}><StarIcon /></div></StyledTableCell> */}

                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

        </div>
    );
}

function PaginatedItems({ itemsPerPage, ordershistory }) {
    const [currentItems, setCurrentItems] = useState(null);
    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);
    const Favorites = useSelector((state) => state.order.Favorites)

    useEffect(() => {
        const endOffset = itemOffset + itemsPerPage;
        setCurrentItems(ordershistory.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(ordershistory.length / itemsPerPage));
    }, [itemOffset, itemsPerPage, Favorites]);

    const handlePageClick = (event) => {
        const newOffset = event.selected * itemsPerPage % ordershistory.length;
        setItemOffset(newOffset);
    };

    return (
        <>
            {currentItems && <Container>
                <Items currentItems={currentItems} Favorites={Favorites} />
            </Container>}
            <div style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
            }}>
                <Pagination data-testid="paginate">
                    <ReactPaginate 
                        nextLabel=">"
                        onPageChange={handlePageClick}
                        pageRangeDisplayed={3}
                        marginPagesDisplayed={2}
                        pageCount={pageCount}
                        previousLabel="<"
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        breakLabel="..."
                        breakClassName="page-item"
                        breakLinkClassName="page-link"
                        containerClassName="pagination"
                        activeClassName="active"
                        renderOnZeroPageCount={null}
                    />
                </Pagination>
            </div>
        </>
    );
}


const Pagination = styled.div`
margin-top : 10px;
.page-item.active .page-link {
    background-color: #eb1700 !important;
    border-color: #fff !important;
}

.page-link {
    color: #444 !important;
    /* border : none !important; */
    /* border-radius: 5px; */
}

.page-link:hover {
    color: #444 !important;
}

`;

const Container = styled.div`
    margin-top: 1%;
    margin-left: 5%;
    margin-right: 5%;
    margin-bottom: 1%;
    @media (max-width: 768px) {
        margin-left: 0;
        margin-right: 0;
    }
`;
